var _path, _path2, _path3, _path4, _path5, _path6;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgListView(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 11,
    height: 10,
    viewBox: "0 0 11 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.25 0.75C1.38807 0.75 1.5 0.861929 1.5 1C1.5 1.13807 1.38807 1.25 1.25 1.25C1.11193 1.25 1 1.13807 1 1C1 0.861929 1.11193 0.75 1.25 0.75Z",
    fill: "#1859B4",
    stroke: "#1859B4"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M3.5 1H10.5",
    stroke: "#1859B4",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M1.25 4.75C1.38807 4.75 1.5 4.86193 1.5 5C1.5 5.13807 1.38807 5.25 1.25 5.25C1.11193 5.25 1 5.13807 1 5C1 4.86193 1.11193 4.75 1.25 4.75Z",
    fill: "#1859B4",
    stroke: "#1859B4"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M3.5 5H10.5",
    stroke: "#1859B4",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M1.25 8.75C1.38807 8.75 1.5 8.86193 1.5 9C1.5 9.13807 1.38807 9.25 1.25 9.25C1.11193 9.25 1 9.13807 1 9C1 8.86193 1.11193 8.75 1.25 8.75Z",
    fill: "#1859B4",
    stroke: "#1859B4"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M3.5 9H10.5",
    stroke: "#1859B4",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgListView);
export default __webpack_public_path__ + "static/media/listView.672f0f9c887aa023e6ce4af0741d4523.svg";
export { ForwardRef as ReactComponent };